import React from 'react';
import { colors, fonts } from './theme';

/**
 * Global styles – professional, restrained aesthetic
 */
const GlobalStyles: React.FC = () => (
  <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

    *, *::before, *::after {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
    }

    html {
      font-size: 16px;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      text-rendering: optimizeLegibility;
    }

    body {
      font-family: ${fonts.family};
      font-size: ${fonts.base};
      font-weight: ${fonts.normal};
      line-height: ${fonts.lineHeightNormal};
      color: ${colors.text};
      background-color: ${colors.bgLight};
      min-height: 100vh;
    }

    #root {
      min-height: 100vh;
      display: flex;
      flex-direction: column;
    }

    h1, h2, h3, h4, h5, h6 {
      font-weight: ${fonts.semibold};
      line-height: ${fonts.lineHeightTight};
      color: ${colors.text};
    }

    h1 { font-size: ${fonts['3xl']}; }
    h2 { font-size: ${fonts['2xl']}; }
    h3 { font-size: ${fonts.xl}; }
    h4 { font-size: ${fonts.lg}; }

    p {
      margin-bottom: 1rem;
    }

    a {
      color: ${colors.primary};
      text-decoration: underline;
      text-decoration-color: ${colors.border};
      text-underline-offset: 2px;
      transition: text-decoration-color 150ms ease;
    }

    a:hover {
      text-decoration-color: ${colors.primary};
    }

    button {
      font-family: inherit;
      cursor: pointer;
    }

    button:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

    *:focus-visible {
      outline: 2px solid ${colors.focus};
      outline-offset: 2px;
    }

    ::selection {
      background-color: ${colors.primary};
      color: ${colors.white};
    }

    ::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }

    ::-webkit-scrollbar-track {
      background: ${colors.bgLight};
    }

    ::-webkit-scrollbar-thumb {
      background: ${colors.border};
      border-radius: 4px;
    }

    ::-webkit-scrollbar-thumb:hover {
      background: ${colors.textMuted};
    }

    input[type="number"]::-webkit-inner-spin-button,
    input[type="number"]::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    .sr-only {
      position: absolute;
      width: 1px;
      height: 1px;
      padding: 0;
      margin: -1px;
      overflow: hidden;
      clip: rect(0, 0, 0, 0);
      white-space: nowrap;
      border: 0;
    }
  `}</style>
);

export default GlobalStyles;
